export const RefundStatus = Object.freeze({
  PENDING: 'pending',
  PARTIALLY_REFUNDED: 'refunded_partial',
  REFUNDED: 'refunded',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  FULLY_CONSUMED: 'fully_consumed'
})

export const PaymentStatus = Object.freeze({
  PENDING: 'pending',
  PAID: 'paid',
  CANCELED: 'canceled',
  PAID_PARTIAL: 'paid_partial'
})

export const SecurityDepositPaymentStatus = Object.freeze({
  PENDING: 'pending',
  PAID: 'paid',
  PAID_PARTIAL: 'paid_partial'
})

export const SecurityDepositConsumeStatus = Object.freeze({
  // pending if the consume paid payment is in approval state
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
})

const paymentStatusText = {
  [PaymentStatus.PENDING]: 'Pending',
  [PaymentStatus.PAID]: 'Paid',
  [PaymentStatus.CANCELED]: 'Canceled',
  [PaymentStatus.PAID_PARTIAL]: 'Partial Payment'
}

const refundStatusText = {
  [RefundStatus.APPROVED]: 'Approved',
  [RefundStatus.PENDING]: 'Pending',
  [RefundStatus.PARTIALLY_REFUNDED]: 'Partially Refunded',
  [RefundStatus.REFUNDED]: 'Refunded',
  [RefundStatus.REJECTED]: 'Rejected',
  [RefundStatus.FULLY_CONSUMED]: 'Fully Consumed'
}

export function parsePaymentStatus(raw) {
  return paymentStatusText[raw] || raw
}

export function parseRefundStatus(raw) {
  return refundStatusText[raw] || raw
}
